/*@ngInject*/
const DropdownSearchController = function ($scope, $element, $timeout, coreConstant) {

    const timeoutList = [];

    this.$onInit = function () {
        $element.addClass('umDropdownSearchComponent');
    };

    this.$postLink = function () {
        this.applyFocusToSearch();
    };

    this.applyFocusToSearch = function () {
        $scope.setFocus('.umPopover .optionListSearchInput');
    };

    this.onInputChange = _.debounce(() => {
        this.onChange({searchTerm: this.searchTerm});
        timeoutList.push($timeout(function () {}, 0));
    }, 750);

    this.onClearSearchClick = function () {
        this.searchTerm = '';
        this.onInputChange();
        this.applyFocusToSearch();
    };

    $scope.$on(coreConstant.event.dropdown.searchInterface.FOCUS_CLEAR_SEARCH_INPUT_BUTTON, () => {
        this.searchInterfaceFocus = true;
        timeoutList.push($timeout(function () {}, 0));
    });

    $scope.$on(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SEARCH_INPUT_BUTTON, () => {
        this.searchInterfaceFocus = false;
        timeoutList.push($timeout(function () {}, 0));
    });

    $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLEAR_SEARCH_INPUT, () => {
        this.onClearSearchClick();
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (timeout) {
            $timeout.cancel(timeout);
        });
    });
};

angular.module('umCore')
    .controller('umDropdownSearchController', DropdownSearchController);
